export const HttpStatusCode = {
  OK: 200,
  ACCEPTED: 202,
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  GATEWAY_TIMEOUT: 504
} as const

export type HttpStatusCodeType = (typeof HttpStatusCode)[keyof typeof HttpStatusCode]
